<template>
  <s-crud @returnObject='refresh($event)'
    no-border
    title="Clima de Zona"
    :config="this.config"
    @save="save($event)"
    add
    @clearForm="clearForm()"
    edit
    restore
    @rowSelected="rowSelected($event)" 
    remove
    :filter="filter"
  >
    <template slot="filter">
      <v-container fluid>
        <v-row class="d-flex justify-start" dense>
          <v-col lg="4" md="4" sm="12" cols="12" class="s-col-form">
            <s-selected-zona
              v-model="filter.ZonID"
              no-default
              clearable
              full
              label="Zona"
            />
          </v-col>
          <v-col lg="4" md="4" sm="6" cols="12" class="s-col-form">
            <s-date v-model="filter.BeginDate" label="Fecha Inicio" clearable />
          </v-col>
          <v-col lg="4" md="4" sm="6" cols="12" class="s-col-form">
            <s-date v-model="filter.EndDate" label="Fecha Fin" clearable />
          </v-col>
        </v-row>
      </v-container>
    </template>
    <template scope="props">
      <v-container v-if="props.item != null" class="pb-0">
        <v-row dense>
          <!-- Primera Fila -->
          <v-col lg="4" md="4" sm="12" cols="12" class="s-col-form">
            <s-selected-zona
              :text="props.item.ZonDescription"
              v-model="props.item.SelectedZonaObj"
              return-object
              full
              label="Zona"
            />
          </v-col>
          <v-col lg="3" md="3" sm="5" cols="5" class="s-col-form">
            <s-text decimal disabled :value="props.item.SelectedZonaObj ? props.item.SelectedZonaObj.Latitude : ''" label="Latitud" />
          </v-col>
          <v-col lg="3" md="3" sm="5" cols="5" class="s-col-form">
            <s-text decimal disabled :value="props.item.SelectedZonaObj ? props.item.SelectedZonaObj.Longitude : ''" label="Longitud" />
          </v-col>
          <v-col lg="2" md="2" sm="2" cols="2" class="s-col-form d-flex align-end pb-1">
            <v-btn
              color="primary"
              block
              small
              height="40"
              :loading="loadingWeather"
              @click="consultWeather(props.item)"
            >
              <v-icon left>mdi-cloud-search</v-icon>
              Consultar
            </v-btn>
          </v-col>

          <!-- Segunda Fila -->
          <v-col lg="4" md="4" sm="6" cols="12" class="s-col-form">
            <s-date ref="RegistrationDate" v-model="props.item.RegistrationDate" label="Fecha Registro" />
          </v-col>
          <v-col lg="4" md="4" sm="6" cols="12" class="s-col-form">
            <s-time ref="Time" v-model="props.item.Time" label="Hora Registro" />
          </v-col>
          <v-col lg="4" md="4" sm="6" cols="12" class="s-col-form">
            <s-text decimal ref="TempCelsius" v-model="props.item.TempCelsius" label="Temperatura (°C)" />
          </v-col>

          <!-- Tercera Fila -->
          <v-col lg="4" md="4" sm="6" cols="12" class="s-col-form">
            <s-text decimal ref="Hum" v-model="props.item.Hum" label="Humedad (%)" />
          </v-col>
          <v-col lg="4" md="4" sm="6" cols="12" class="s-col-form">
            <s-text decimal ref="Wind" v-model="props.item.Wind" label="Viento (km/h)" />
          </v-col>
          <v-col lg="4" md="4" sm="6" cols="12" class="s-col-form">
            <s-text decimal ref="Rain" v-model="props.item.Rain" label="Lluvia (mm)" />
          </v-col>

          <!-- Cuarta Fila -->
          <v-col lg="4" md="4" sm="6" cols="12" class="s-col-form">
            <s-text decimal ref="Bar" v-model="props.item.Bar" label="Presión Barométrica (hPa)" />
          </v-col>
          <v-col lg="4" md="4" sm="6" cols="12" class="s-col-form">
            <s-text decimal ref="Evapo" v-model="props.item.Evapo" label="Evapotranspiración (mm)" />
          </v-col>
          <v-col lg="4" md="4" sm="6" cols="12" class="s-col-form">
            <s-text decimal ref="Solar" v-model="props.item.Solar" label="Radiación Solar (W/m²)" />
          </v-col>

          <!-- Quinta Fila -->
          <v-col lg="4" md="4" sm="6" cols="12" class="s-col-form">
            <s-text decimal ref="UV" v-model="props.item.UV" label="Índice UV" />
          </v-col>
        </v-row>
      </v-container>
    </template>
  </s-crud>
</template>

<script>
import _sAreaWeather from "@/services/Technicalassistance/AreaWeatherService.js";
import sSelectedZona from "@/components/TecnicalAssistence/ProducersFarms/sSelectedZona";

export default {
  components: {
    sSelectedZona,
  },
  data: () => ({
    loadingWeather: false,
    filter: {
      ZonID: null,
      BeginDate: null,
      EndDate: null,
    },
    config: {
      title: "Clima de Zona",
      service: _sAreaWeather,
      model: {
        AwID: "ID",
        ZonID: "int",
        TempCelsius: "decimal",
        Wind: "decimal",
        Hum: "decimal",
        Rain: "decimal",
        Bar: "decimal",
        Solar: "decimal",
        UV: "decimal",
        Evapo: "decimal",
        SecStatus: "status",
        ZonDescription: "string",
        RegistrationDate: "date",
        Time: "string",
      },
      headers: [
        {
          text: "ID",
          value: "AwID",
          width: "5%",
          align: "end",
          sorteable: true,
        },
        {
          text: "Zona",
          value: "ZonDescription",
          width: "20%",
          sorteable: true,
        },
        {
          text: "Fecha Reg.",
          value: "RegistrationDate",
          width: "10%",
          align: "center",
          sorteable: true,
        },
        {
          text: "Hora Reg.",
          value: "Time",
          width: "8%",
          align: "center",
          sorteable: true,
        },
        {
          text: "Temp. (°C)",
          value: "TempCelsius",
          width: "8%",
          align: "center",
          sorteable: true,
        },
        {
          text: "Humedad (%)",
          value: "Hum",
          width: "8%",
          align: "center",
          sorteable: true,
        },
        {
          text: "Viento (km/h)",
          value: "Wind",
          width: "8%",
          align: "center",
          sorteable: true,
        },
        {
          text: "Lluvia (mm)",
          value: "Rain",
          width: "8%",
          align: "center",
          sorteable: true,
        },
        {
          text: "Presión (hPa)",
          value: "Bar",
          width: "8%",
          align: "center",
          sorteable: true,
        },
        {
          text: "Evapo. (mm)",
          value: "Evapo",
          width: "8%",
          align: "center",
          sorteable: true,
        },
        {
          text: "Rad. Solar (W/m²)",
          value: "Solar",
          width: "8%",
          align: "center",
          sorteable: true,
        },
        {
          text: "UV",
          value: "UV",
          width: "5%",
          align: "center",
          sorteable: true,
        },
      ],
    },
  }),
  methods: {
    consultWeather(item) {
      if (!item.SelectedZonaObj || !item.SelectedZonaObj.Latitude || !item.SelectedZonaObj.Longitude) {
        this.$fun.alert("La zona seleccionada no tiene latitud y longitud configuradas.", "warning");
        return;
      }
      this.loadingWeather = true;
      _sAreaWeather.getWeatherExternal(
        item.SelectedZonaObj.Latitude,
        item.SelectedZonaObj.Longitude,
        this.$fun.getUserID()
      )
      .then(r => {
        if (r.status === 200 && r.data && r.data.current) {
          const current = r.data.current;
          this.$set(item, "TempCelsius", current.temperature_2m);
          this.$set(item, "Hum", current.relative_humidity_2m);
          this.$set(item, "Wind", current.wind_speed_10m);
          this.$set(item, "Rain", current.precipitation);
          this.$set(item, "Bar", current.surface_pressure);
          this.$set(item, "Solar", current.shortwave_radiation);
          this.$set(item, "UV", current.uv_index);

          if (current.time) {
            const parts = current.time.split("T");
            if (parts.length === 2) {
              this.$set(item, "RegistrationDate", parts[0]);
              this.$set(item, "Time", parts[1]);
              this.syncTimeField(item);
            }
          }

          if (r.data.hourly && r.data.hourly.time && r.data.hourly.evapotranspiration) {
            const currentHourStr = current.time ? current.time.substring(0, 13) : "";
            const hourlyIndex = r.data.hourly.time.findIndex(t => t.startsWith(currentHourStr));
            if (hourlyIndex !== -1) {
              this.$set(item, "Evapo", r.data.hourly.evapotranspiration[hourlyIndex]);
            }
          }
          
          this.$fun.alert("Datos climáticos obtenidos correctamente.", "success");
        } else {
          this.$fun.alert("No se pudo obtener la información del clima.", "error");
        }
      })
      .catch(e => {
        this.$fun.alert("Error al consultar el clima: " + (e.message || e), "error");
      })
      .finally(() => {
        this.loadingWeather = false;
      });
    },
    syncTimeField(item) {
      this.$nextTick(() => {
        let timeComponent = this.$refs.Time;
        if (Array.isArray(timeComponent)) {
          timeComponent = timeComponent[0];
        }
        if (timeComponent && item && item.Time) {
          timeComponent.valueModel = item.Time;
          timeComponent.valuePicker = item.Time;
        }
      });
    },
    rowSelected(items) {
      if (items && items.length > 0) {
        const item = items[0];
        if (item.ZonID && !item.SelectedZonaObj) {
          this.$set(item, "SelectedZonaObj", {
            ZonID: item.ZonID,
            ZonDescription: item.ZonDescription,
          });
        }
        this.syncTimeField(item);
      }
      console.log(items);
      this.$emit("rowSelected", items);
    },
    refresh(item) {
      this.$emit("refresh", item);
    },
    clearForm() {
      // Limpieza adicional si se requiere
    },
    save(item) {
      item.SecStatus = 1;
      if (item.SelectedZonaObj) {
        item.ZonID = item.SelectedZonaObj.ZonID;
        item.ZonDescription = item.SelectedZonaObj.ZonDescription;
      }
      if (!item.ZonID) {
        this.$fun.alert("Seleccione una Zona", "warning");
        return;
      }
      item.save();
    },
  },
};
</script>
